<template>
  <SpinnerComp v-if="loading" />
  <div v-else>
    <TableComp
      :data="{
        title: 'Notas',
        buttons: [{ text: 'Nueva Nota', action: openModal }],
        headers: [
          'id',
          'Asunto',
          'Descripcion',
          'Inicio',
          'Vencimiento',
          'Estado',
          'Prioridad',
          'Opciones',
        ],
        visibleColumnsMobile: [1, 4, 5, 6, 7],
        ocultar: [0],
      }"
      :rows="rows"
      :options="options"
      @option-click="handleOptionAction"
    />

    <Modal
      v-if="isModalOpen"
      :isOpen="isModalOpen"
      :title="'Nueva Nota'"
      :fields="formFields"
      :submitButtonText="'Guardar Nota'"
      @close="closeModal"
      v-model="formData"
      @submit="dataForm"
    />

    <ModalUpdateComp
      v-if="isModalUpdate"
      :title="'Actualizar Nota'"
      :isOpen="isModalUpdate"
      :selectedData="selectedRow"
      :formFields="formFields"
      @update:selectedData="updateRowData"
      @close="closeModal"
      @updateData="updateNotes"
    />

    <DeleteComp
      v-if="isDeleteOpen"
      :isOpen="isDeleteOpen"
      :deleteMessage="deleteMessage"
      @close="closeModal"
      @confirm="deleteNotes"
    />
  </div>
</template>

<script>
import TableComp from "@/components/TableComp.vue";
import Modal from "@/components/ModalComp.vue";
import ModalUpdateComp from "@/components/ModalUpdateComp.vue";
import DeleteComp from "@/components/DeleteComp.vue";
import SpinnerComp from "@/components/SpinnerComp.vue";
export default {
  components: {
    TableComp,
    Modal,
    DeleteComp,
    ModalUpdateComp,
    SpinnerComp,
  },
  data() {
    return {
      loading: false,
      isModalOpen: false,
      isDeleteOpen: false,
      isModalUpdate: false,
      isSubmitting: false,
      rows: [],
      formFields: [
        { label: "Asunto", model: "asunto", placeholder: "Asunto" },
        {
          label: "Descripción",
          model: "descripcion",
          placeholder: "Descripción",
          type: "textarea",
        },
        {
          label: "Inicio",
          model: "fechaInicio",
          type: "date",
        },
        {
          label: "Vencimiento",
          model: "fechaVence",
          type: "date",
        },
        {
          label: "Estado",
          model: "estado",
          type: "select",
          options: [
            { label: "No Comenzada", value: "No Comenzada" },
            { label: "En curso", value: "En curso" },
            { label: "En Progreso", value: "En Progreso" },
            { label: "Completada", value: "Completada" },
          ],
        },
        {
          label: "Prioridad",
          model: "prioridad",
          type: "select",
          options: [
            { label: " Baja", value: "Baja" },
            { label: " Normal", value: "Normal" },
            { label: " Alta", value: "Alta" },
          ],
        },
      ],
      options: [
        {
          icon: "material-symbols-outlined edit",
          action: "edit",
          color: "bg-yellow-300",
        },
        {
          icon: "material-symbols-outlined delete",
          action: "delete",
          color: "bg-red-500",
        },
      ],
    };
  },
  methods: {
    openModal() {
      this.isModalOpen = true;
    },
    closeModal() {
      this.isModalOpen = false;
      this.isModalUpdate = false;
      this.isDeleteOpen = false;
    },
    handleOptionAction(action, row) {
      if (action === "edit") {
        this.selectedRow = { ...row };
        this.isModalUpdate = true;
        this.id = row.id;
      } else if (action === "delete") {
        this.deleteMessage = `¿Estás seguro de que deseas eliminar: ${row.asunto}?`;
        this.isDeleteOpen = true;
        this.id = row.id;
      }
    },
    getData() {
      this.loading = true;
      this.$axios
        .get("/getNot")
        .then((response) => {
          this.rows = response.data.notas.map((item) => ({
            id: item.id,
            asunto: item.asunto,
            descripcion: item.descripcion,
            fechaInicio: item.fechaInicio,
            fechaVence: item.fechaVence,
            estado: item.estado,
            prioridad: item.prioridad,
          }));
        })
        .catch((error) => {
          alert(error.response.data.message);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    dataForm(formData) {
      if (this.isSubmitting) return;
      this.isSubmitting = true;
      this.$axios
        .post("/registerNot", formData)
        .then((response) => {
          alert(response.data.message);
          this.closeModal();
          this.getData();
        })
        .catch((error) => {
          alert(error.response.data.message);
        }).finally(() => {
          this.isSubmitting = false;
        });
    },
    deleteNotes() {
      if (this.isSubmitting) return;
      this.isSubmitting = true;
      this.$axios
        .delete(`/deleteNot/${this.id}`)
        .then((response) => {
          this.closeModal();
          alert(response.data.message);
          this.getData();
        })
        .catch((error) => {
          if (error.response) {
            alert(error.response.data.message);
          }
        }).finally(() => {
          this.isSubmitting = false;
        });
    },
    updateNotes(updateData) {
      if (this.isSubmitting) return;
      this.isSubmitting = true;
      this.$axios
        .put(`/updateNot/${this.id}`, updateData)
        .then((response) => {
          alert(response.data.message);
          this.closeModal();
        })
        .catch((error) => {
          alert(error.response.data.message);
        }).finally(() => {
          this.isSubmitting = false;
        });
    },
  },
  mounted() {
    this.getData();
  },
};
</script>
